const fontSizes = [
  { label: 'Small', value: 0.75 },
  { label: 'Standard', value: 1 },
  { label: 'Large', value: 1.25 },
  { label: 'Extra Large', value: 1.5 },
]

module.exports = fontSizes
